@if (availableInstruments) {
  <div class="list-container">
    @for (instrument of availableInstruments | paginate: paginationConfig; track instrument.instrumentId) {
      <div class="toggler-container">
        <libero-available-instrument-toggler
          [availableInstrument]="instrument"
          [selectedPerformance]="selectedPerformance"
          [hideAddButtons]="hideAddButtons"
        ></libero-available-instrument-toggler>
      </div>
    }
  </div>
}

<pagination-template #p="paginationApi" class="pagination-custom-control" [id]="paginationConfig.id!" (pageChange)="paginationConfig.currentPage = $event">

  <div class="pagination-arrow pagination-previous " [ngClass]="{ 'pagination-arrow--inactive': p.isFirstPage() }">
    <a
      (click)="p.previous()"
      (keydown.space)="!p.isFirstPage() && p.previous()"
      (keydown.enter)="!p.isFirstPage() && p.previous()"
      tabindex="0"
      >
      <svg-icon src="assets/icons/chevron-down.svg" [svgStyle]="{ 'width.px':18, 'transform': 'rotate(90deg)' }"></svg-icon>
    </a>
  </div>

  @for (page of p.pages; track page.value) {
    <div [class.current]="p.getCurrent() === page.value">
      @if (p.getCurrent() !== page.value) {
        <a
          (click)="p.setCurrent(page.value)"
          class="inactive-page"
          [attr.data-cy]="'available-page-instruments-' + page.value"
          (keydown.space)="p.setCurrent(page.value)"
          (keydown.enter)="p.setCurrent(page.value)"
          tabindex="0"
          >
          <span>{{ page.label }}</span>
        </a>
      }
      @if (p.getCurrent() === page.value) {
        <div class="current-page" data-cy="current-page-instruments">
          <span>{{ page.label }}</span>
        </div>
      }
    </div>
  }

  <div class="pagination-arrow pagination-next " [ngClass]="{ 'pagination-arrow--inactive': p.isLastPage() }">
    <a
      (click)="p.next()"
      (keydown.space)="!p.isLastPage() && p.next()"
      (keydown.enter)="!p.isLastPage() && p.next()"
      tabindex="0">
      <svg-icon src="assets/icons/chevron-down.svg" [svgStyle]="{ 'width.px':18, 'transform': 'rotate(270deg)' }"></svg-icon>
    </a>
  </div>
</pagination-template>
